export default __webpack_public_path__ + "static/media/escuela_verde_primaria.2f133382.jpg";